module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n    Payment preferences\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin top-margin"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentPreferenceSelected),
      expression: "paymentPreferenceSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "paymentPreferenceSelected_Input",
      "name": "paymentPreferenceSelected_Input"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.paymentPreferenceSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.paymentPreferences.DONATE.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.DONATE.label) + "\n          ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.paymentPreferences.PAYOUT.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.PAYOUT.label) + "\n          ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.paymentPreferences.REINVEST.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.REINVEST.label) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestPreferenceSelected),
      expression: "interestPreferenceSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "interestPreferenceSelected_Input",
      "name": "interestPreferenceSelected_Input"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestPreferenceSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.paymentPreferences.DONATE.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.DONATE.label) + "\n          ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.paymentPreferences.PAYOUT.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.PAYOUT.label) + "\n          ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.paymentPreferences.REINVEST.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.REINVEST.label) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n    Note Restrictions\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox bottom-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redemptionRestrictionSelected),
      expression: "redemptionRestrictionSelected"
    }],
    attrs: {
      "type": "checkbox",
      "id": "notesRestriction_Input"
    },
    domProps: {
      "checked": Array.isArray(_vm.redemptionRestrictionSelected) ? _vm._i(_vm.redemptionRestrictionSelected, null) > -1 : (_vm.redemptionRestrictionSelected)
    },
    on: {
      "change": _vm.handleNotesRestrictionChange,
      "__c": function($event) {
        var $$a = _vm.redemptionRestrictionSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.redemptionRestrictionSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.redemptionRestrictionSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.redemptionRestrictionSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n           Enable Redemptions with Upcoming Transactions\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n    General Communication Preferences\n  ")]), _vm._v(" "), (_vm.communicationPreferences.EMAIL !== undefined) ? _c('div', {
    staticClass: "row bottom-margin top-margin"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    class: _vm.communicationPreferenceSelected === _vm.communicationPreferences.EMAIL.name ?
      'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.communicationPreferenceSelected),
      expression: "communicationPreferenceSelected"
    }],
    attrs: {
      "id": "communicationPreference_Email",
      "name": "communicationPreference_Email",
      "type": "radio"
    },
    domProps: {
      "value": _vm.communicationPreferences.EMAIL.name,
      "checked": _vm._q(_vm.communicationPreferenceSelected, _vm.communicationPreferences.EMAIL.name)
    },
    on: {
      "__c": function($event) {
        _vm.communicationPreferenceSelected = _vm.communicationPreferences.EMAIL.name
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "communicationPreference_Email"
    }
  }, [_vm._v(_vm._s(_vm.communicationPreferences.EMAIL.label))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    class: _vm.communicationPreferenceSelected === _vm.communicationPreferences.SNAIL_MAIL.name ?
      'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.communicationPreferenceSelected),
      expression: "communicationPreferenceSelected"
    }],
    attrs: {
      "id": "communicationPreference_SnailMail",
      "name": "communicationPreference_SnailMmail",
      "type": "radio"
    },
    domProps: {
      "value": _vm.communicationPreferences.SNAIL_MAIL.name,
      "checked": _vm._q(_vm.communicationPreferenceSelected, _vm.communicationPreferences.SNAIL_MAIL.name)
    },
    on: {
      "__c": function($event) {
        _vm.communicationPreferenceSelected = _vm.communicationPreferences.SNAIL_MAIL.name
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "communicationPreference_SnailMail"
    }
  }, [_vm._v(_vm._s(_vm.communicationPreferences.SNAIL_MAIL.label))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n    Specific Communication Preferences\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin top-margin"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "panel-subtitle"
  }, [_vm._v("\n        1099\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form1099Email),
      expression: "form1099Email"
    }],
    attrs: {
      "type": "checkbox",
      "id": "form1099_email",
      "name": "form1099_email"
    },
    domProps: {
      "checked": Array.isArray(_vm.form1099Email) ? _vm._i(_vm.form1099Email, null) > -1 : (_vm.form1099Email)
    },
    on: {
      "change": _vm.handleForm1099EmailChange,
      "__c": function($event) {
        var $$a = _vm.form1099Email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form1099Email = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form1099Email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form1099Email = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Email\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form1099SnailMail),
      expression: "form1099SnailMail"
    }],
    attrs: {
      "type": "checkbox",
      "id": "form1099_snailmail",
      "name": "form1099_snailmail"
    },
    domProps: {
      "checked": Array.isArray(_vm.form1099SnailMail) ? _vm._i(_vm.form1099SnailMail, null) > -1 : (_vm.form1099SnailMail)
    },
    on: {
      "change": _vm.handleForm1099SnailMailChange,
      "__c": function($event) {
        var $$a = _vm.form1099SnailMail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form1099SnailMail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form1099SnailMail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form1099SnailMail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Snail Mail\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "panel-subtitle"
  }, [_vm._v("\n        Impact Report\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.impactReportEmail),
      expression: "impactReportEmail"
    }],
    attrs: {
      "type": "checkbox",
      "id": "impactReport_email",
      "name": "impactReport_email"
    },
    domProps: {
      "checked": Array.isArray(_vm.impactReportEmail) ? _vm._i(_vm.impactReportEmail, null) > -1 : (_vm.impactReportEmail)
    },
    on: {
      "change": _vm.handleImpactReportEmailChange,
      "__c": function($event) {
        var $$a = _vm.impactReportEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.impactReportEmail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.impactReportEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.impactReportEmail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Email\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.impactReportSnailMail),
      expression: "impactReportSnailMail"
    }],
    attrs: {
      "type": "checkbox",
      "id": "impactReport_snailmail",
      "name": "impactReport_snailmail"
    },
    domProps: {
      "checked": Array.isArray(_vm.impactReportSnailMail) ? _vm._i(_vm.impactReportSnailMail, null) > -1 : (_vm.impactReportSnailMail)
    },
    on: {
      "change": _vm.handleImpactReportSnailMailChange,
      "__c": function($event) {
        var $$a = _vm.impactReportSnailMail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.impactReportSnailMail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.impactReportSnailMail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.impactReportSnailMail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Snail Mail\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin top-margin"
  }, [_vm._v("\n    Impact preferences\n  ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.displayedPreferences.length > 0 && _vm.nonDisplayedPreferences.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected),
      expression: "displayedPreferences[indexOfGeneralPreference].isSelected"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.displayedPreferences[_vm.indexOfGeneralPreference].id,
      "disabled": false
    },
    domProps: {
      "value": _vm.displayedPreferences[_vm.indexOfGeneralPreference].id,
      "checked": Array.isArray(_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected) ? _vm._i(_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected, _vm.displayedPreferences[_vm.indexOfGeneralPreference].id) > -1 : (_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected)
    },
    on: {
      "change": _vm.onChangeSelectImpactPreference,
      "__c": function($event) {
        var $$a = _vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.displayedPreferences[_vm.indexOfGeneralPreference].id,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Where Calvert Impact Capital sees the most need and opportunity\n        ")])]), _vm._v(" "), _vm._l((_vm.displayedPreferences), function(preference, index) {
    return (!_vm.isGeneralPreference(index) && !_vm.isOtherPreference(index)) ? _c('div', {
      key: index,
      staticClass: "checkbox c-checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (preference.isSelected),
        expression: "preference.isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": preference.id,
        "disabled": false
      },
      domProps: {
        "value": preference.id,
        "checked": Array.isArray(preference.isSelected) ? _vm._i(preference.isSelected, preference.id) > -1 : (preference.isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = preference.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = preference.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (preference.isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (preference.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            preference.isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n          " + _vm._s(preference.preferenceText) + "\n        ")])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.nonDisplayedPreferences), function(preference, index) {
    return _c('div', {
      key: index,
      staticClass: "checkbox c-checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (preference.isSelected),
        expression: "preference.isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": preference.id,
        "disabled": false
      },
      domProps: {
        "value": preference.id,
        "checked": Array.isArray(preference.isSelected) ? _vm._i(preference.isSelected, preference.id) > -1 : (preference.isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = preference.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = preference.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (preference.isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (preference.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            preference.isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n          " + _vm._s(preference.preferenceText) + "\n        ")])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('RestrictedSingleInput', {
    attrs: {
      "dual": true,
      "input": _vm.other,
      "limit": 50,
      "warningLimit": 29,
      "fieldLabel": "Other",
      "instructionsLabel": "Make sure your text doesn't exceed 50 characters.",
      "placeholderText": 'Enter your preference here...'
    },
    on: {
      "inputUpdated": _vm.selectOtherPreference
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg button-submit",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.showConfirmationModal
    }
  }, [_vm._v("Submit preferences")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "paymentPreferenceSelected_Input"
    }
  }, [_vm._v("\n          Principal maturity preference "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "interestPreferenceSelected_Input"
    }
  }, [_vm._v("\n          Interest payment preference "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "panel-subtitle"
  }, [_vm._v("\n        Displayed\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "panel-subtitle"
  }, [_vm._v("\n        Non displayed\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-292eef6d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountPreferences.vue
// module id = 2129
// module chunks = 1